import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import { useTheme } from '@emotion/react';
import { Done } from 'emotion-icons/material';
import * as React from 'react';
import Brandy from '../Brandy/index.js';
import ListItem from '../List/ListItem.js';
import Typography from '../Typography/index.js';
import { PriceWrapper, Before, Price as Price$2, AmountWrapper, SymbolAndDollarAmount, Currency, DollarAmount, CentsAndDuration, ChangeAmount, Divider, Duration, DisclaimersWrapper, Disclaimer, Bullets } from './Price.styles.js';

var _excluded = ["amount", "large", "condensed", "before", "duration", "children", "nutrition", "bullets", "showFeaturedBullets", "inPackageCard", "variant", "priceOld", "price", "priceDuration", "priceIntro", "priceOutro"];

/* eslint-disable react/no-danger */
var Price = function Price(_ref) {
  var _pricing$split, _components$Price, _components$Price2, _pricing$split2, _pricing$split3, _components$Price3, _pricing$split$, _components$Price4, _pricing$split$2, _pricing$split4, _pricing$split$3, _components$Price5, _pricing$split$4, _pricing$split5, _components$Price6, _props$disclaimer, _props$disclaimer2;
  var amount = _ref.amount,
    _ref$large = _ref.large,
    large = _ref$large === void 0 ? false : _ref$large,
    _ref$condensed = _ref.condensed,
    condensed = _ref$condensed === void 0 ? false : _ref$condensed,
    _ref$before = _ref.before,
    before = _ref$before === void 0 ? null : _ref$before,
    duration = _ref.duration,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$nutrition = _ref.nutrition,
    nutrition = _ref$nutrition === void 0 ? null : _ref$nutrition,
    _ref$bullets = _ref.bullets,
    bullets = _ref$bullets === void 0 ? null : _ref$bullets,
    _ref$showFeaturedBull = _ref.showFeaturedBullets,
    showFeaturedBullets = _ref$showFeaturedBull === void 0 ? null : _ref$showFeaturedBull,
    _ref$inPackageCard = _ref.inPackageCard,
    inPackageCard = _ref$inPackageCard === void 0 ? false : _ref$inPackageCard,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? null : _ref$variant,
    _ref$priceOld = _ref.priceOld,
    priceOld = _ref$priceOld === void 0 ? null : _ref$priceOld,
    _ref$price = _ref.price,
    price = _ref$price === void 0 ? null : _ref$price,
    priceDuration = _ref.priceDuration,
    _ref$priceIntro = _ref.priceIntro,
    priceIntro = _ref$priceIntro === void 0 ? null : _ref$priceIntro,
    _ref$priceOutro = _ref.priceOutro,
    priceOutro = _ref$priceOutro === void 0 ? null : _ref$priceOutro,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    components = _useTheme.components;
  var pricing = price || amount;
  var pricingDuration = priceDuration || duration || '/mo';

  // if nutrition is a string (from brandy), render it as HTML since they use tags, otherwise render it as whatever
  var nutritionComponent = typeof nutrition === 'string' && nutrition !== '' ? /*#__PURE__*/React.createElement(Typography, {
    variant: "legal",
    className: "nutrition",
    dangerouslySetInnerHTML: {
      __html: "".concat(nutrition).trim()
    }
  }) : nutrition && /*#__PURE__*/React.createElement("span", {
    className: "nutrition"
  }, nutrition);
  return /*#__PURE__*/React.createElement(PriceWrapper, null, /*#__PURE__*/React.createElement(Before, {
    className: "before",
    inPackageCard: inPackageCard
  }, priceIntro || 'Starting at'), /*#__PURE__*/React.createElement(Price$2, _extends({
    className: "leshen-price",
    condensed: condensed,
    large: large,
    "aria-label": "".concat(before || '', " $").concat(amount, " per ").concat(pricingDuration),
    variant: variant || 'body',
    durationUnderPrice: pricingDuration.length > 6 && inPackageCard,
    longDuration: pricingDuration.length > 6
  }, props, {
    inPackageCard: inPackageCard
  }), priceOld && /*#__PURE__*/React.createElement(Typography, {
    className: "price-old",
    variant: "body",
    strikethrough: true,
    customWeight: "700"
  }, "$", priceOld), /*#__PURE__*/React.createElement(PriceWrapper, {
    className: "leshen-price-wrapper package-default"
  }, /*#__PURE__*/React.createElement(AmountWrapper, {
    inPackageCard: inPackageCard,
    className: "leshen-price-amount-wrapper"
  }, /*#__PURE__*/React.createElement(SymbolAndDollarAmount, {
    inPackageCard: inPackageCard
  }, /*#__PURE__*/React.createElement(Currency, {
    className: "leshen-price-currency",
    inPackageCard: inPackageCard
  }, "$")), /*#__PURE__*/React.createElement(DollarAmount, {
    className: "leshen-price-dollar",
    inPackageCard: inPackageCard
  }, pricing === null || pricing === void 0 || (_pricing$split = pricing.split('.')) === null || _pricing$split === void 0 ? void 0 : _pricing$split[0]), (components === null || components === void 0 || (_components$Price = components.Price) === null || _components$Price === void 0 || (_components$Price = _components$Price.duration) === null || _components$Price === void 0 ? void 0 : _components$Price.position) === 'underCents' ? /*#__PURE__*/React.createElement(CentsAndDuration, {
    inPackageCard: inPackageCard
  }, /*#__PURE__*/React.createElement(ChangeAmount, {
    inPackageCard: inPackageCard,
    className: "leshen-price-change"
  }, /*#__PURE__*/React.createElement("span", null, !(components !== null && components !== void 0 && (_components$Price2 = components.Price) !== null && _components$Price2 !== void 0 && _components$Price2.noDecimal) && (pricing === null || pricing === void 0 || (_pricing$split2 = pricing.split('.')) === null || _pricing$split2 === void 0 || (_pricing$split2 = _pricing$split2[1]) === null || _pricing$split2 === void 0 ? void 0 : _pricing$split2.length) > 0 && '.', /*#__PURE__*/React.createElement("span", null, pricing === null || pricing === void 0 || (_pricing$split3 = pricing.split('.')) === null || _pricing$split3 === void 0 ? void 0 : _pricing$split3[1])), /*#__PURE__*/React.createElement(Divider, {
    inPackageCard: inPackageCard
  })), /*#__PURE__*/React.createElement(Duration, {
    className: "leshen-price-duration",
    inPackageCard: inPackageCard
  }, /*#__PURE__*/React.createElement("span", {
    className: "duration-html",
    dangerouslySetInnerHTML: {
      __html: "".concat(pricingDuration).trim()
    }
  }))) : (components === null || components === void 0 || (_components$Price3 = components.Price) === null || _components$Price3 === void 0 || (_components$Price3 = _components$Price3.duration) === null || _components$Price3 === void 0 ? void 0 : _components$Price3.position) === 'underPrice' ? /*#__PURE__*/React.createElement(React.Fragment, null, pricing[1] && ((_pricing$split$ = pricing.split('.')[1]) === null || _pricing$split$ === void 0 ? void 0 : _pricing$split$.length) > 0 && /*#__PURE__*/React.createElement(ChangeAmount, {
    className: "leshen-price-change",
    inPackageCard: inPackageCard
  }, !(components !== null && components !== void 0 && (_components$Price4 = components.Price) !== null && _components$Price4 !== void 0 && _components$Price4.noDecimal) && ((_pricing$split$2 = pricing.split('.')[1]) === null || _pricing$split$2 === void 0 ? void 0 : _pricing$split$2.length) > 0 && '.', /*#__PURE__*/React.createElement("span", null, pricing === null || pricing === void 0 || (_pricing$split4 = pricing.split('.')) === null || _pricing$split4 === void 0 ? void 0 : _pricing$split4[1]))) : /*#__PURE__*/React.createElement(React.Fragment, null, (pricing === null || pricing === void 0 ? void 0 : pricing[1]) && ((_pricing$split$3 = pricing.split('.')[1]) === null || _pricing$split$3 === void 0 ? void 0 : _pricing$split$3.length) > 0 && /*#__PURE__*/React.createElement(ChangeAmount, {
    inPackageCard: inPackageCard,
    className: "leshen-price-change"
  }, !(components !== null && components !== void 0 && (_components$Price5 = components.Price) !== null && _components$Price5 !== void 0 && _components$Price5.noDecimal) && ((_pricing$split$4 = pricing.split('.')[1]) === null || _pricing$split$4 === void 0 ? void 0 : _pricing$split$4.length) > 0 && '.', /*#__PURE__*/React.createElement("span", null, pricing === null || pricing === void 0 || (_pricing$split5 = pricing.split('.')) === null || _pricing$split5 === void 0 ? void 0 : _pricing$split5[1])), /*#__PURE__*/React.createElement(Duration, {
    className: "leshen-price-duration",
    inPackageCard: inPackageCard
  }, /*#__PURE__*/React.createElement("span", {
    className: "duration-html",
    dangerouslySetInnerHTML: {
      __html: "".concat(pricingDuration).trim()
    }
  })))), (components === null || components === void 0 || (_components$Price6 = components.Price) === null || _components$Price6 === void 0 || (_components$Price6 = _components$Price6.duration) === null || _components$Price6 === void 0 ? void 0 : _components$Price6.position) === 'underPrice' && /*#__PURE__*/React.createElement(Duration, {
    className: "leshen-price-duration",
    inPackageCard: inPackageCard
  }, /*#__PURE__*/React.createElement("span", {
    className: "duration-html",
    dangerouslySetInnerHTML: {
      __html: "".concat(pricingDuration).trim()
    }
  })), /*#__PURE__*/React.createElement(DisclaimersWrapper, {
    className: "leshen-price-disclaimers-wrapper"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, (props === null || props === void 0 ? void 0 : props.disclaimer) && /*#__PURE__*/React.createElement(Disclaimer, {
    symbol: props === null || props === void 0 || (_props$disclaimer = props.disclaimer) === null || _props$disclaimer === void 0 ? void 0 : _props$disclaimer.symbol,
    text: props === null || props === void 0 || (_props$disclaimer2 = props.disclaimer) === null || _props$disclaimer2 === void 0 ? void 0 : _props$disclaimer2.text,
    variant: "legal",
    styles: variant,
    className: "leshen-price-duration-disclaimer"
  }), children && /*#__PURE__*/React.createElement("span", {
    className: "modal"
  }, children), nutritionComponent && nutritionComponent, priceOutro && priceOutro)))), bullets && showFeaturedBullets && /*#__PURE__*/React.createElement(Bullets, {
    className: "leshen-price-list"
  }, bullets === null || bullets === void 0 ? void 0 : bullets.map(function (bullet) {
    return /*#__PURE__*/React.createElement(ListItem, {
      className: "leshen-price-list-item",
      key: bullet === null || bullet === void 0 ? void 0 : bullet.text,
      icon: /*#__PURE__*/React.createElement(Done, null)
    }, /*#__PURE__*/React.createElement(Brandy, {
      text: bullet === null || bullet === void 0 ? void 0 : bullet.text,
      variant: "body"
    }), bullet.disclaimer && /*#__PURE__*/React.createElement(Brandy, {
      symbol: bullet === null || bullet === void 0 ? void 0 : bullet.disclaimer.symbol,
      text: bullet === null || bullet === void 0 ? void 0 : bullet.disclaimer.text,
      variant: "legal"
    }));
  })));
};

/* eslint-enable react/no-danger */
var Price$1 = Price;

export { Price$1 as default };
//# sourceMappingURL=index.js.map
